import React from "react";
import { Icon } from "@iconify/react";
import { useTheme } from "../../../contexts/ThemeContext";

export interface TagProps {
  tag: string;
  onClick?: (tag: string) => void;
  size?: 'sm' | 'md';
  icon?: string;
  disabled?: boolean;
  className?: string;
}

export const Tag: React.FC<TagProps> = ({
  tag,
  onClick,
  size = 'md',
  icon = 'ph:hash-thin',
  disabled = false,
  className = ''
}) => {
  const { theme } = useTheme();

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    if (!disabled && onClick) {
      onClick(tag);
    }
  };

  return (
    <button
      onClick={handleClick}
      aria-label={`Tag: ${tag}`}
      className={`
        inline-flex items-center gap-1.5 
        px-3 py-1 rounded-full
        text-sm font-medium
        transition-colors duration-200
        ${disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}
        ${theme.mode === "dark"
          ? "bg-[rgba(255,255,255,0.1)] hover:bg-[rgba(255,255,255,0.15)] text-text-primary"
          : "bg-[rgba(0,0,0,0.05)] hover:bg-[rgba(0,0,0,0.12)] text-text-secondary hover:text-text-primary"
        }
        ${className}
      `}
    >
      <Icon
        icon={icon}
        className="w-3.5 h-3.5 text-inherit"
      />
      {tag}
    </button>
  );
};

export default Tag; 